import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };
  return <header className="sticky top-0 z-50 bg-[#0a1a0f]/95 backdrop-blur-sm border-b border-[#00ff88]/20" data-id="element-55">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="flex justify-between items-center h-16" data-id="element-57">
          <div className="flex items-center space-x-2" data-id="element-58">
            <div className="w-8 h-8 bg-gradient-to-br from-[#00ff88] to-[#22c55e] transform rotate-45 flex items-center justify-center" data-id="element-59">
              <div className="w-4 h-4 bg-[#0a1a0f] transform -rotate-45" data-id="element-60"></div>
            </div>
            <span className="text-xl font-bold tracking-wider text-white" data-id="element-61">
              STEELSERIESHUB
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-62">
            <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-[#00ff88] transition-colors" data-id="element-63">
              Services
            </button>
            <button onClick={() => scrollToSection('results')} className="text-gray-300 hover:text-[#00ff88] transition-colors" data-id="element-64">
              Results
            </button>
            <button onClick={() => scrollToSection('team')} className="text-gray-300 hover:text-[#00ff88] transition-colors" data-id="element-65">
              Team
            </button>
            <button onClick={() => scrollToSection('pricing')} className="text-gray-300 hover:text-[#00ff88] transition-colors" data-id="element-66">
              Pricing
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-[#00ff88] transition-colors" data-id="element-67">
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-white" aria-label="Toggle menu" data-id="element-68">
            {mobileMenuOpen ? <X size={24} data-id="element-69" /> : <Menu size={24} data-id="element-70" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && <div className="md:hidden py-4 space-y-4 border-t border-[#00ff88]/20" data-id="element-71">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-300 hover:text-[#00ff88] transition-colors" data-id="element-72">
              Services
            </button>
            <button onClick={() => scrollToSection('results')} className="block w-full text-left text-gray-300 hover:text-[#00ff88] transition-colors" data-id="element-73">
              Results
            </button>
            <button onClick={() => scrollToSection('team')} className="block w-full text-left text-gray-300 hover:text-[#00ff88] transition-colors" data-id="element-74">
              Team
            </button>
            <button onClick={() => scrollToSection('pricing')} className="block w-full text-left text-gray-300 hover:text-[#00ff88] transition-colors" data-id="element-75">
              Pricing
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-gray-300 hover:text-[#00ff88] transition-colors" data-id="element-76">
              Contact
            </button>
          </div>}
      </nav>
    </header>;
}